var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"flat":"","label":_vm.label,"items":_vm.durations,"item-text":"name","item-value":"id","background-color":_vm.backgroundColor,"outlined":_vm.outlined,"rules":_vm.rules},model:{value:(_vm.selectedDuration),callback:function ($$v) {_vm.selectedDuration=$$v},expression:"selectedDuration"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }